function updateBadge() {
  const badgeCaption = document.querySelector(".stamped-badge-caption");

  if (badgeCaption) {
    const rating = parseFloat(badgeCaption.getAttribute("data-rating")) || 0;
    const reviews = parseInt(badgeCaption.getAttribute("data-reviews"), 10) || 0;

    if (rating > 0) {
      badgeCaption.textContent = `${rating} by ${reviews} Derestricted eBike Riders`;
      console.log("Review badge updated successfully.");
    } else {
      console.log("Rating is 0. No update performed.");
    }
  }
}

// Run every 1 second to ensure updates persist
setInterval(updateBadge, 1000);

const swiper = new Swiper(".swiper", {
  direction: "horizontal",
  loop: true,
  slidesPerView: 2,
  spaceBetween: 15,
  autoplay: {
    delay: 3000,
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 30,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    },
  },
});
const swiper_cover = new Swiper(".swiper-coverflow", {
  direction: "horizontal",
  loop: true,
  slidesPerView: 1,
  spaceBetween: 15,
  effect: "cards",
  perSlideOffset: 100,
  perSlideRotate: 20,
  grabCursor: true,
  centeredSlides: true,
  autoplay: {
    delay: 3000,
  },
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 15,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    },
  },
});

const swiper_cover_2 = new Swiper(".swiper-coverflow-eicma", {
  direction: "horizontal",
  loop: true,
  slidesPerView: 1,
  reverseDirection: true,
  spaceBetween: 15,
  effect: "cards",
  grabCursor: true,
  centeredSlides: true,
  cardsEffect: {
    slideShadows: false, // Disables shadows on slides
  },
  
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 15,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    },
  },
});
